import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";
import NewsletterForm from "@/components/NewsletterForm";

export default function Footer() {
  return (
    <footer className="bg-[#070707] border-t border-white/10 pt-20 pb-10 mt-20" data-testid="site-footer">
      <div className="ankara-strip mb-16" />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-4 gap-12">
        <div>
          <h3 className="font-display text-3xl text-white mb-3">DaviD<span style={{color:"var(--davide-gold)"}}>É</span></h3>
          <p className="text-sm text-white/60 leading-relaxed max-w-xs">
            Global Fashion. Cultural attire meets modern trends — confidence woven into every thread.
          </p>
        </div>
        <div>
          <div className="overline mb-4">Shop</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/shop" className="hover:text-[var(--davide-gold)]">All Products</Link></li>
            <li><Link to="/shop?category=Hoodies" className="hover:text-[var(--davide-gold)]">Hoodies</Link></li>
            <li><Link to="/shop?category=Accessories" className="hover:text-[var(--davide-gold)]">Accessories</Link></li>
            <li><Link to="/shop?category=Footwear" className="hover:text-[var(--davide-gold)]">Footwear</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">About</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/about" className="hover:text-[var(--davide-gold)]">Our Story</Link></li>
            <li><Link to="/community" className="hover:text-[var(--davide-gold)]">YAAIDFI Cause</Link></li>
            <li><a href="https://www.yaaidfi.org" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--davide-gold)]" data-testid="footer-yaaidfi-link">YAAIDFI.org ↗</a></li>
            <li><Link to="/my-orders" className="hover:text-[var(--davide-gold)]" data-testid="footer-orders-link">My Orders</Link></li>
            <li><a href="https://www.rachvidwearsusa.com" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--davide-gold)]" data-testid="footer-rachvid-link">Rachvid Wears ↗</a></li>
            <li><a href="https://www.aliveshoes.com/rachvid" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--davide-gold)]" data-testid="footer-aliveshoes-link">AliveShoes · Rachvid ↗</a></li>
            <li><Link to="/admin/login" className="hover:text-[var(--davide-gold)]" data-testid="footer-admin-link">Admin</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Connect</div>
          <div className="flex gap-4 text-white/70 mb-6">
            <a href="https://www.instagram.com/prophetofluv" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-[var(--davide-gold)]"><Instagram size={20}/></a>
            <a href="https://www.facebook.com/rachvidwears" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-[var(--davide-gold)]"><Facebook size={20}/></a>
            <a href="mailto:hello@davidefashion.com" aria-label="Email" className="hover:text-[var(--davide-gold)]"><Mail size={20}/></a>
          </div>
          <NewsletterForm source="footer" compact testId="footer-newsletter" />
          <p className="text-xs text-white/40 mt-6">© 2026 DaviDÉ Global Fashion. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
